import { styled } from '@mui/material/styles'
import { Link } from 'react-router'
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material'
import { AccountCircleOutlined } from '@mui/icons-material'

export const MenuButton = styled(Button)({
	marginRight: '14px',
	padding: 0,
	minWidth: 'auto',

	'&:focus': {
		outline: 'none',
	},

	'&:hover': {
		backgroundColor: 'transparent',
	},
})

export const CustomMenu = styled(Menu)({
	// Learn's fixed header (StyledAppBar) sits at z-index 1500, so the menu must
	// render above it for the dropdown to overlay the header like Play does
	// instead of being clipped underneath the navbar.
	zIndex: 1600,
	'& .Mui-disabled ': {
		opacity: '1 !important',
	},
})

export const CustomMenuItem = styled(MenuItem)({})

export const MenuLink = styled(Link)({
	width: '100%',
	height: '100%',
	textDecoration: 'none',
	color: '#000',
	padding: '4px 16px',
})

export const UserNavLink = styled('a')({
	color: 'rgba(0, 0, 0, 0.87)',
	textDecoration: 'none',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
})

export const TriggerAvatar = styled('img')({
	width: 40,
	height: 40,
	borderRadius: '100%',
	objectFit: 'cover',
	cursor: 'pointer',
})

export const AccountIcon = styled(AccountCircleOutlined)({
	width: 40,
	height: 40,
	cursor: 'pointer',
})

export const ProfileSummary = styled(MenuItem)({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	width: '100%',
	cursor: 'pointer',
	backgroundColor: 'transparent',
	'&:hover': {
		backgroundColor: 'transparent',
	},
	'&.Mui-selected': {
		backgroundColor: 'transparent',
	},
	'&.Mui-focusVisible': {
		backgroundColor: 'transparent',
	},
})

export const ProfileImage = styled('img')({
	width: '120px',
	height: '120px',
	objectFit: 'cover',
	borderRadius: '100%',
})

export const CustomPerson = styled('img')({
	objectFit: 'cover',
	width: '120px',
	height: '120px',
	borderRadius: '100%',
})

export const ProfileName = styled(Typography)({
	fontWeight: '500',
	marginTop: '5px',
	fontSize: '1.5rem',
	lineHeight: 1.334,
	color: 'rgba(0, 0, 0, 0.87)',
	textAlign: 'center',
})

export const ProfileUsername = styled(Typography)({
	marginTop: '2px',
	marginLeft: '10px',
	color: '#000000',
	fontSize: '18px',
	textAlign: 'center',
})

export const ProfilePlan = styled(Typography)({
	marginTop: '2px',
	marginLeft: '10px',
	color: '#000000',
	fontSize: '18px',
	textAlign: 'center',
})

export const RowIcon = styled(Box)({
	display: 'inline-flex',
	alignItems: 'center',
	'& svg': {
		fontSize: 23,
	},
})

export const RowLabel = styled('span')({
	marginLeft: '10px',
	marginTop: '0px',
	fontSize: '1rem',
})

export const RowLink = styled('a')({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
	color: 'rgba(0, 0, 0, 0.87)',
	textDecoration: 'none',
})

export const RowButton = styled('button')({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
	padding: 0,
	background: 'none',
	border: 'none',
	font: 'inherit',
	color: 'rgba(0, 0, 0, 0.87)',
	textAlign: 'left',
	cursor: 'pointer',
})
